import MasterApi from './MasterApi';

export default class SensorCategory extends MasterApi {
  constructor() {
    super();
    this.masterName = 'sensor_category';
  }
}
